module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Cold War began shortly after the end of the Second World War and concluded with the collapse of the Soviet Union in 1991. The leading contenders, the United States and the Soviet Union, were engaged in an arms race, with each side constantly introducing ever more costly and complex weapon systems. These ranged from tanks to nuclear-armed intercontinental ballistic missiles (ICBMs). Not all met the respective users’ expectations, with some proving to be design dead ends. In this book, the author’s intent is somewhat limited and only addresses the development of Soviet aviation during the Cold War. For those wishing for more information on particular aircraft featured in the book, there are many well-researched references available on a significant number of them.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ea652e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Introduction.vue
// module id = 75
// module chunks = 0